<template lang="pug">
#appBar
  v-app-bar#home-app-bar(app, elevation='1', elevate-on-scroll, height='80')
    v-container.app-bar-inner
      nuxt-link.app-brand-link(
        :to='localePath("/")'
        :aria-label='t("nav.homeLabel")'
      )
        base-img(
          :src='logoSrc',
          alt='EOTLAB'
          contain,
          max-width='230',
          width='100%'
        )
      v-spacer
      nav.desktop-nav.hidden-sm-and-down(:aria-label='t("nav.primary")')
        nuxt-link.desktop-nav-link.font-weight-bold(
          v-for='(name, i) in items',
          :key='i',
          :to='name.slug',
          :class='{ "desktop-nav-link--active": isItemActive(name.slug) }'
        )
          span.desktop-nav-label {{ name.title }}
        LanguageSwitcher.desktop-language-switcher
      v-app-bar-nav-icon.hidden-md-and-up(
        :aria-label='t("nav.openMenu")'
        @click='drawer = !drawer'
      )
  ClientOnly
    HomeDrawer(v-model='drawer', :items='items')
</template>

<script setup>
import HomeDrawer from '~/layouts/Drawer.vue'
import { useRoute } from 'nuxt/app'
import { stripLocalePrefix } from '~/utils/i18n'

defineOptions({
  name: 'HomeAppBar',
})

const route = useRoute()
const { t } = useI18n()
const localePath = useLocalePath()
const logoSrc = '/media/brand/EoT-blue-full-3.png'

const drawer = ref(null)
const items = computed(() => [
  { title: t('nav.home'), slug: localePath('/') },
  { title: t('nav.news'), slug: localePath('/articles') },
  { title: t('nav.team'), slug: localePath('/persons') },
  { title: t('nav.publications'), slug: localePath('/publications') },
  { title: t('nav.theses'), slug: localePath('/theses') },
])

function isItemActive(slug) {
  const currentPath = stripLocalePrefix(route.path)
  const itemPath = stripLocalePrefix(slug)

  if (itemPath === '/') {
    return currentPath === '/'
  }

  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`)
}
</script>

<style lang="sass">
#home-app-bar
  border-bottom: 1px solid rgba(43, 51, 59, 0.12)

  .v-toolbar__content
    color: var(--color-text-strong)

  .app-bar-inner
    display: flex
    align-items: center
    width: 100%
    min-height: 80px

  .app-brand-link
    display: inline-flex
    align-items: center
    text-decoration: none

  .desktop-nav
    display: flex
    align-items: center
    gap: 0.35rem

  .desktop-nav-link
    display: inline-flex
    align-items: center
    min-height: 80px
    padding: 0 1rem
    color: var(--color-text-strong)
    text-decoration: none
    position: relative

    text-transform: none
    letter-spacing: 0
    transition: color 0.2s ease

    &:hover
      color: var(--brand-primary)

    &::after
      content: ''
      position: absolute
      left: 50%
      bottom: 12px
      width: 24px
      height: 2px
      background: var(--brand-primary)
      transform: translateX(-50%) scaleX(0)
      transform-origin: center
      transition: transform 0.2s ease

  .desktop-nav-link--active
    color: var(--brand-primary)

    &::after
      transform: translateX(-50%) scaleX(1)

  .desktop-nav-label
    font-weight: 700

  .desktop-language-switcher
    margin-left: 0.65rem
</style>
